import React, { createContext, useContext, ReactNode } from 'react';

// 仓库数据类型
export interface WarehouseData {
    id: string;
    name?: string;
    siteType?: number;
    sortingCode?: string;
    parentSiteId?: string | number;
    [key: string]: any;
}

// 仓库上下文类型
export interface WarehouseContextType {
    currentWarehouse: WarehouseData | null;
    changeWarehouse?: (warehouseId: string, siteType: number) => void;
}

// 创建Context
export const WarehouseContext = createContext<WarehouseContextType>({
    currentWarehouse: null,
    changeWarehouse: undefined
});

// Provider组件
interface WarehouseProviderProps {
    children: ReactNode;
    currentWarehouse: WarehouseData | null;
    changeWarehouse?: (warehouseId: string, siteType: number) => void;
}

export const WarehouseProvider: React.FC<WarehouseProviderProps> = ({ 
    children, 
    currentWarehouse,
    changeWarehouse
}) => {
    return (
        <WarehouseContext.Provider value={{ currentWarehouse, changeWarehouse }}>
            {children}
        </WarehouseContext.Provider>
    );
};

// Hook
export const useWarehouseContext = () => {
    const context = useContext(WarehouseContext);
    if (context === undefined) {
        throw new Error('useWarehouseContext must be used within a WarehouseProvider');
    }
    return context;
};
